import { Component } from '@angular/core';

@Component({
    selector: 'app-benefit-info',
    templateUrl: './benefit-info.component.html',
    styleUrl: './benefit-info.component.scss',
    standalone: true
})
export class BenefitInfoComponent {

}
